import { render, staticRenderFns } from "./friends-page.vue?vue&type=template&id=bb71e1d4&scoped=true&"
import script from "./friends-page.vue?vue&type=script&lang=js&"
export * from "./friends-page.vue?vue&type=script&lang=js&"
import style0 from "./friends-page.vue?vue&type=style&index=0&id=bb71e1d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb71e1d4",
  null
  
)

export default component.exports